import React from 'react';

const Step2 = ({ value, onChange, onSubmit, backButton, toggleClick }) => {
  return (
    <section className="stack stack--large stretch phm" id="step-3">
      <div className="live-quote__header capped row row-pushed mbl">
        <button onClick={backButton} className="live-quote__back">
          <span className="is-hidden-visually">Back</span>
        </button>
        <div>
          <strong>Step 2 of 4</strong>
        </div>
        <button className="live-quote__close" onClick={toggleClick}>
          <div className="is-hidden-visually">Close</div>
        </button>
      </div>
      <div className="stack centered">
        <h1 className="c-heading c-heading-lg heading-cofo">
          Apparel Chair Info
        </h1>
      </div>
      <form
        className="live-quote-animated capped-narrow stack"
        onSubmit={e => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <div className="stack stack--small">
          <label className="input-label" htmlFor="apparel-chair-first-name">
            Apparel Chair First Name*
          </label>
          <input
            className="field"
            type="text"
            id="apparel-chair-first-name"
            value={value.apparelChairFirstName}
            required={true}
            placeholder="Ex: Johnny"
            onChange={e => {
              onChange({ ...value, apparelChairFirstName: e.target.value });
            }}
          />
        </div>

        <div className="stack stack--small">
          <label className="input-label" htmlFor="apparel-chair-last-name">
            Apparel Chair Last Name*
          </label>
          <input
            className="field"
            type="text"
            id="apparel-chair-last-name"
            value={value.apparelChairLastName}
            required={true}
            placeholder="Ex: Appleseed"
            onChange={e => {
              onChange({ ...value, apparelChairLastName: e.target.value });
            }}
          />
        </div>

        <div className="stack stack--small">
          <label className="input-label" htmlFor="apparel-chair-email">
            Apparel Chair Email*
          </label>
          <input
            className="field"
            type="email"
            id="apparel-chair-email"
            required={true}
            placeholder="Ex: email@address.com"
            value={value.apparelChairEmail}
            onChange={e => {
              onChange({ ...value, apparelChairEmail: e.target.value });
            }}
          />
        </div>

        <div className="stack stack--small">
          <label className="input-label" htmlFor="apparel-chair-phone">
            Apparel Chair Phone Number*
          </label>
          <input
            className="field"
            type="tel"
            id="apparel-chair-phone"
            required={true}
            value={value.apparelChairPhone}
            placeholder="Ex: 555-555-5555"
            onChange={e => {
              onChange({ ...value, apparelChairPhone: e.target.value });
            }}
          />
        </div>

        <div className="centered mtl">
          <button className="button">Next Step</button>
        </div>
      </form>
    </section>
  );
};

export default Step2;
